import { get } from "./config";

const Time = {
  getServerTime: async ({ signal } = {}) => {
    const { data } = await get("/v1/time", {
      signal,
      timeout: 10000,
      skipAuth: true,
      headers: { Accept: "application/json" },
    });
    return data;
  },
};

export default Time;
